// actions/core/pages.js

import { attachAuth } from '../../utils/authService';

export function pageHasErrored(bool) {
  return {
    type: 'PAGE_HAS_ERRORED',
    hasErrored: bool
  };
}

export function pageIsLoading(bool) {
  return {
    type: 'PAGE_IS_LOADING',
    isLoading: bool
  };
}

export function pageFetchDataSuccess(response) {
  return {
    type: 'PAGE_FETCH_DATA_SUCCESS',
    response
  };
}

export function pageFetchData(host, params) {
  return (dispatch) => {
    dispatch(pageIsLoading(true));
    dispatch(pageHasErrored(false));
    fetch(host + 'catalog/pages', {
      method: 'post',
      body: JSON.stringify(params),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(pageFetchDataSuccess(result));
            dispatch(pageHasErrored(false));
            dispatch(pageIsLoading(false));
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(pageHasErrored(true));
            dispatch(pageIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(pageHasErrored(true));
      dispatch(pageIsLoading(false));
    });
  };
}